// These constants are used as skip links and aria-expanded id's for the model filter
export const SKIP_ID_RESULTS = "model-results-main";
export const CONTROL_ID_FILTERS = "model-filter-filters";
export const SKIP_ID_FILTERS = "model-results-filtering";
